<template>
  <div class="container-fluid bg-dark text-white text-center p-5" id="footer">
    Powered by <a href="https://azuatech.co.ke">AzuaTech</a>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>

</style>
